import { render, staticRenderFns } from "./AdminMember.vue?vue&type=template&id=4fb7cfa6"
import script from "./AdminMember.vue?vue&type=script&lang=js"
export * from "./AdminMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports